/**
 * 文件库常量定义
 */

import { PermissionLevel, AccessLogAction, FolderType } from './enums';

/** 权限级别标签 */
export const PERMISSION_LEVEL_LABELS: Record<PermissionLevel, string> = {
  [PermissionLevel.NONE]: '无权限',
  [PermissionLevel.VIEW]: '查看',
  [PermissionLevel.EDIT]: '编辑',
  [PermissionLevel.MANAGE]: '管理',
};

/** 权限级别选项 */
export const PERMISSION_LEVEL_OPTIONS = [
  { value: PermissionLevel.NONE, label: '无权限' },
  { value: PermissionLevel.VIEW, label: '查看' },
  { value: PermissionLevel.EDIT, label: '编辑' },
  { value: PermissionLevel.MANAGE, label: '管理' },
];

/** 操作类型标签 */
export const ACCESS_LOG_ACTION_LABELS: Record<AccessLogAction, string> = {
  [AccessLogAction.VIEW]: '查看',
  [AccessLogAction.DOWNLOAD]: '下载',
  [AccessLogAction.UPLOAD]: '上传',
  [AccessLogAction.UPDATE]: '更新',
  [AccessLogAction.DELETE]: '删除',
  [AccessLogAction.MOVE]: '移动',
  [AccessLogAction.COPY]: '复制',
  [AccessLogAction.PERMISSION_CHANGE]: '权限变更',
  [AccessLogAction.VERSION_UPLOAD]: '版本上传',
  [AccessLogAction.VERSION_ROLLBACK]: '版本回退',
};

/** 文件夹类型标签 */
export const FOLDER_TYPE_LABELS: Record<FolderType, string> = {
  [FolderType.NORMAL]: '普通目录',
  [FolderType.SYSTEM]: '系统目录',
};

/** 可预览的文件扩展名 */
export const PREVIEWABLE_EXTENSIONS = {
  images: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'],
  documents: ['pdf'],
};

/** 默认文件夹图标 */
export const DEFAULT_FOLDER_ICONS = [
  { value: 'folder', label: '文件夹' },
  { value: 'blueprint', label: '图纸' },
  { value: 'file-text', label: '文档' },
  { value: 'solution', label: 'SOP' },
  { value: 'audit', label: '检验' },
  { value: 'bar-chart', label: '报告' },
  { value: 'tool', label: '维护' },
  { value: 'camera', label: '拍照' },
  { value: 'book', label: '手册' },
  { value: 'file-image', label: '图片' },
];

/** 文件夹颜色选项 */
export const FOLDER_COLORS = [
  { value: '#1890ff', label: '蓝色' },
  { value: '#52c41a', label: '绿色' },
  { value: '#faad14', label: '橙色' },
  { value: '#eb2f96', label: '粉色' },
  { value: '#722ed1', label: '紫色' },
  { value: '#13c2c2', label: '青色' },
  { value: '#8c8c8c', label: '灰色' },
  { value: '#f5222d', label: '红色' },
];
